<script lang="ts">
  import ExpandableAccordion from "./ExpandableAccordion.svelte";
  import { _ } from "svelte-i18n";
  import Typography from "../Typography/Typography.svelte";
  import { processInlineLinks } from "$lib/utils/url";
  import { onMount } from "svelte";

  export let openOneOnly: boolean;
  export let border: boolean;
  export let iconType: string = "PLUSMINUS";
  export let accordions: Array<{
    title: string;
    body: string;
    openOnLoad: boolean;
    border: boolean;
    invert: boolean;
    open?: boolean;
  }>;

  onMount(() => {
    accordions = accordions.map(item => ({
      ...item,
      open: item.openOnLoad,
    }));
  });

  $: accordions = accordions.filter(a => a);
</script>

<style lang="scss">
  .invert {
    background-color: $inverse-surface;
  }
</style>

<div class={`expandable-section-container`}>
  {#each accordions as { title: cardTitle, body, border: cardBorder, invert, open }, index}
    <div class={`${invert ? "invert" : ""}`}>
      <ExpandableAccordion
        title={$_(cardTitle)}
        caret={iconType === "CARET"}
        small={true}
        {border}
        innerBorder={cardBorder}
        {index}
        light={invert}
        {invert}
        on:accordionToggle={e => {
          if (e.detail !== null) {
            accordions[index].open = !accordions[index].open;

            if (openOneOnly) {
              accordions = accordions.map((item, i) => ({
                ...item,
                open: i === e.detail ? item.open : false,
              }));
            }
          }
        }}
        accordionOpen={open}
      >
        <Typography
          variant="body1"
          component="p"
          theme={invert ? "background" : "on-background"}
        >
          {@html processInlineLinks($_(body))}
        </Typography>
      </ExpandableAccordion>
    </div>
  {/each}
</div>
